import {trackAmplitudeViewSection} from "../../../tracking/amplitude/track_amplitude_view_section";
import {PRICES_HUB_ANALYTICS_LOCATION} from "./prices_hub_analytics";

export type PricesHubSectionName = "popular_searches" | "transaction_prices" | "data_sources" | "shorts" | "faq" | "articles" | "popular_locations";

export const trackPricesHubViewSection = (sectionName: PricesHubSectionName) => {
    trackAmplitudeViewSection({
        sectionName,
        location: PRICES_HUB_ANALYTICS_LOCATION
    });
};
import {trackAmplitudeViewSection} from "../../../tracking/amplitude/track_amplitude_view_section";
import {PRICES_HUB_ANALYTICS_LOCATION} from "./prices_hub_analytics";

export type PricesHubSectionName = "popular_searches" | "transaction_prices" | "data_sources" | "shorts" | "faq" | "articles" | "popular_locations";

export const trackPricesHubViewSection = (sectionName: PricesHubSectionName) => {
    trackAmplitudeViewSection({
        sectionName,
        location: PRICES_HUB_ANALYTICS_LOCATION
    });
};
